module.exports = __webpack_public_path__ + "static/img/banner4.5f9a0b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner4.jpg
// module id = jnCk
// module chunks = 1